// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,json_types=true"
// @generated from file brands/v1/service.proto (package brands.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file brands/v1/service.proto.
 */
export const file_brands_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message brands.v1.Color
 */
export type Color = Message<"brands.v1.Color"> & {
	/**
	 * @generated from field: string hex = 1;
	 */
	hex: string;

	/**
	 * @generated from field: brands.v1.ColorTheme theme = 2;
	 */
	theme: ColorTheme;

	/**
	 * @generated from field: int32 brightness = 3;
	 */
	brightness: number;

	/**
	 * @generated from field: brands.v1.ColorType type = 4;
	 */
	type: ColorType;
};

/**
 * @generated from message brands.v1.Color
 */
export type ColorJson = {
	/**
	 * @generated from field: string hex = 1;
	 */
	hex?: string;

	/**
	 * @generated from field: brands.v1.ColorTheme theme = 2;
	 */
	theme?: ColorThemeJson;

	/**
	 * @generated from field: int32 brightness = 3;
	 */
	brightness?: number;

	/**
	 * @generated from field: brands.v1.ColorType type = 4;
	 */
	type?: ColorTypeJson;
};

/**
 * Describes the message brands.v1.Color.
 * Use `create(ColorSchema)` to create a new message.
 */
export const ColorSchema: GenMessage<Color, { jsonType: ColorJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 0);

/**
 * @generated from message brands.v1.Image
 */
export type Image = Message<"brands.v1.Image"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: int32 height = 2;
	 */
	height: number;

	/**
	 * @generated from field: int32 width = 3;
	 */
	width: number;

	/**
	 * @generated from field: int32 size = 4;
	 */
	size: number;

	/**
	 * @generated from field: brands.v1.ImageFormat format = 5;
	 */
	format: ImageFormat;

	/**
	 * @generated from field: brands.v1.ImageTheme theme = 6;
	 */
	theme: ImageTheme;

	/**
	 * @generated from field: brands.v1.ImageType type = 7;
	 */
	type: ImageType;

	/**
	 * @generated from field: string display_name = 8;
	 */
	displayName: string;

	/**
	 * @generated from field: brands.v1.ImageBackground background = 9;
	 */
	background: ImageBackground;
};

/**
 * @generated from message brands.v1.Image
 */
export type ImageJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: int32 height = 2;
	 */
	height?: number;

	/**
	 * @generated from field: int32 width = 3;
	 */
	width?: number;

	/**
	 * @generated from field: int32 size = 4;
	 */
	size?: number;

	/**
	 * @generated from field: brands.v1.ImageFormat format = 5;
	 */
	format?: ImageFormatJson;

	/**
	 * @generated from field: brands.v1.ImageTheme theme = 6;
	 */
	theme?: ImageThemeJson;

	/**
	 * @generated from field: brands.v1.ImageType type = 7;
	 */
	type?: ImageTypeJson;

	/**
	 * @generated from field: string display_name = 8;
	 */
	displayName?: string;

	/**
	 * @generated from field: brands.v1.ImageBackground background = 9;
	 */
	background?: ImageBackgroundJson;
};

/**
 * Describes the message brands.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, { jsonType: ImageJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 1);

/**
 * @generated from message brands.v1.Font
 */
export type Font = Message<"brands.v1.Font"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: brands.v1.FontOrigin origin = 2;
	 */
	origin: FontOrigin;

	/**
	 * @generated from field: brands.v1.FontUseCase use_case = 3;
	 */
	useCase: FontUseCase;

	/**
	 * @generated from field: string origin_id = 4;
	 */
	originId: string;
};

/**
 * @generated from message brands.v1.Font
 */
export type FontJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: brands.v1.FontOrigin origin = 2;
	 */
	origin?: FontOriginJson;

	/**
	 * @generated from field: brands.v1.FontUseCase use_case = 3;
	 */
	useCase?: FontUseCaseJson;

	/**
	 * @generated from field: string origin_id = 4;
	 */
	originId?: string;
};

/**
 * Describes the message brands.v1.Font.
 * Use `create(FontSchema)` to create a new message.
 */
export const FontSchema: GenMessage<Font, { jsonType: FontJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 2);

/**
 * @generated from message brands.v1.CodeVariant
 */
export type CodeVariant = Message<"brands.v1.CodeVariant"> & {
	/**
	 * @generated from field: string template_id = 1;
	 */
	templateId: string;

	/**
	 * @generated from field: string template_version = 2;
	 */
	templateVersion: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 3;
	 */
	config?: JsonObject | undefined;
};

/**
 * @generated from message brands.v1.CodeVariant
 */
export type CodeVariantJson = {
	/**
	 * @generated from field: string template_id = 1;
	 */
	templateId?: string;

	/**
	 * @generated from field: string template_version = 2;
	 */
	templateVersion?: string;

	/**
	 * @generated from field: google.protobuf.Struct config = 3;
	 */
	config?: StructJson;
};

/**
 * Describes the message brands.v1.CodeVariant.
 * Use `create(CodeVariantSchema)` to create a new message.
 */
export const CodeVariantSchema: GenMessage<CodeVariant, { jsonType: CodeVariantJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 3);

/**
 * @generated from message brands.v1.BrandKit
 */
export type BrandKit = Message<"brands.v1.BrandKit"> & {
	/**
	 * @generated from field: string id = 7;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 9;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string state = 10;
	 */
	state: string;

	/**
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string name = 12;
	 */
	name: string;

	/**
	 * @generated from field: optional string description = 13;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: string folder_path = 14;
	 */
	folderPath: string;

	/**
	 * @generated from field: string visibility = 21;
	 */
	visibility: string;

	/**
	 * @generated from field: repeated string tags = 15;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated brands.v1.Color primary_colors = 1;
	 */
	primaryColors: Color[];

	/**
	 * @generated from field: repeated brands.v1.Color secondary_colors = 2;
	 */
	secondaryColors: Color[];

	/**
	 * @generated from field: repeated brands.v1.Color tertiary_colors = 3;
	 */
	tertiaryColors: Color[];

	/**
	 * @generated from field: repeated brands.v1.Image primary_images = 4;
	 */
	primaryImages: Image[];

	/**
	 * @generated from field: repeated brands.v1.Image secondary_images = 5;
	 */
	secondaryImages: Image[];

	/**
	 * @generated from field: repeated brands.v1.Font fonts = 6;
	 */
	fonts: Font[];

	/**
	 * Key is a CodeType
	 *
	 * @generated from field: map<string, brands.v1.CodeVariant> code_variants = 19;
	 */
	codeVariants: { [key: string]: CodeVariant };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional string derived_from_hostname = 18;
	 */
	derivedFromHostname?: string | undefined;
};

/**
 * @generated from message brands.v1.BrandKit
 */
export type BrandKitJson = {
	/**
	 * @generated from field: string id = 7;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 9;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string state = 10;
	 */
	state?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string name = 12;
	 */
	name?: string;

	/**
	 * @generated from field: optional string description = 13;
	 */
	description?: string;

	/**
	 * @generated from field: string folder_path = 14;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string visibility = 21;
	 */
	visibility?: string;

	/**
	 * @generated from field: repeated string tags = 15;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated brands.v1.Color primary_colors = 1;
	 */
	primaryColors?: ColorJson[];

	/**
	 * @generated from field: repeated brands.v1.Color secondary_colors = 2;
	 */
	secondaryColors?: ColorJson[];

	/**
	 * @generated from field: repeated brands.v1.Color tertiary_colors = 3;
	 */
	tertiaryColors?: ColorJson[];

	/**
	 * @generated from field: repeated brands.v1.Image primary_images = 4;
	 */
	primaryImages?: ImageJson[];

	/**
	 * @generated from field: repeated brands.v1.Image secondary_images = 5;
	 */
	secondaryImages?: ImageJson[];

	/**
	 * @generated from field: repeated brands.v1.Font fonts = 6;
	 */
	fonts?: FontJson[];

	/**
	 * Key is a CodeType
	 *
	 * @generated from field: map<string, brands.v1.CodeVariant> code_variants = 19;
	 */
	codeVariants?: { [key: string]: CodeVariantJson };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: TimestampJson;

	/**
	 * @generated from field: optional string derived_from_hostname = 18;
	 */
	derivedFromHostname?: string;
};

/**
 * Describes the message brands.v1.BrandKit.
 * Use `create(BrandKitSchema)` to create a new message.
 */
export const BrandKitSchema: GenMessage<BrandKit, { jsonType: BrandKitJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 4);

/**
 * Must pass either URL or BrandKit in request. If both present, BrandKit takes precedence.
 *
 * @generated from message brands.v1.CreateBrandKitRequest
 */
export type CreateBrandKitRequest = Message<"brands.v1.CreateBrandKitRequest"> & {
	/**
	 * @deprecated used GenerateBrandKit instead
	 *
	 * @generated from field: string brand_url = 1 [deprecated = true];
	 * @deprecated
	 */
	brandUrl: string;

	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 2;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * Must pass either URL or BrandKit in request. If both present, BrandKit takes precedence.
 *
 * @generated from message brands.v1.CreateBrandKitRequest
 */
export type CreateBrandKitRequestJson = {
	/**
	 * @deprecated used GenerateBrandKit instead
	 *
	 * @generated from field: string brand_url = 1 [deprecated = true];
	 * @deprecated
	 */
	brandUrl?: string;

	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 2;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.CreateBrandKitRequest.
 * Use `create(CreateBrandKitRequestSchema)` to create a new message.
 */
export const CreateBrandKitRequestSchema: GenMessage<CreateBrandKitRequest, { jsonType: CreateBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 5);

/**
 * @generated from message brands.v1.CreateBrandKitResponse
 */
export type CreateBrandKitResponse = Message<"brands.v1.CreateBrandKitResponse"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * @generated from message brands.v1.CreateBrandKitResponse
 */
export type CreateBrandKitResponseJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.CreateBrandKitResponse.
 * Use `create(CreateBrandKitResponseSchema)` to create a new message.
 */
export const CreateBrandKitResponseSchema: GenMessage<CreateBrandKitResponse, { jsonType: CreateBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 6);

/**
 * @generated from message brands.v1.GenerateBrandKitRequest
 */
export type GenerateBrandKitRequest = Message<"brands.v1.GenerateBrandKitRequest"> & {
	/**
	 * @generated from field: string brand_url = 1;
	 */
	brandUrl: string;
};

/**
 * @generated from message brands.v1.GenerateBrandKitRequest
 */
export type GenerateBrandKitRequestJson = {
	/**
	 * @generated from field: string brand_url = 1;
	 */
	brandUrl?: string;
};

/**
 * Describes the message brands.v1.GenerateBrandKitRequest.
 * Use `create(GenerateBrandKitRequestSchema)` to create a new message.
 */
export const GenerateBrandKitRequestSchema: GenMessage<GenerateBrandKitRequest, { jsonType: GenerateBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 7);

/**
 * @generated from message brands.v1.GenerateBrandKitResponse
 */
export type GenerateBrandKitResponse = Message<"brands.v1.GenerateBrandKitResponse"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * @generated from message brands.v1.GenerateBrandKitResponse
 */
export type GenerateBrandKitResponseJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.GenerateBrandKitResponse.
 * Use `create(GenerateBrandKitResponseSchema)` to create a new message.
 */
export const GenerateBrandKitResponseSchema: GenMessage<GenerateBrandKitResponse, { jsonType: GenerateBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 8);

/**
 * @generated from message brands.v1.UpdateBrandKitRequest
 */
export type UpdateBrandKitRequest = Message<"brands.v1.UpdateBrandKitRequest"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message brands.v1.UpdateBrandKitRequest
 */
export type UpdateBrandKitRequestJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message brands.v1.UpdateBrandKitRequest.
 * Use `create(UpdateBrandKitRequestSchema)` to create a new message.
 */
export const UpdateBrandKitRequestSchema: GenMessage<UpdateBrandKitRequest, { jsonType: UpdateBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 9);

/**
 * @generated from message brands.v1.UpdateBrandKitResponse
 */
export type UpdateBrandKitResponse = Message<"brands.v1.UpdateBrandKitResponse"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * @generated from message brands.v1.UpdateBrandKitResponse
 */
export type UpdateBrandKitResponseJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.UpdateBrandKitResponse.
 * Use `create(UpdateBrandKitResponseSchema)` to create a new message.
 */
export const UpdateBrandKitResponseSchema: GenMessage<UpdateBrandKitResponse, { jsonType: UpdateBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 10);

/**
 * @generated from message brands.v1.ListBrandKitsRequest
 */
export type ListBrandKitsRequest = Message<"brands.v1.ListBrandKitsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string creator_ids = 8;
	 */
	creatorIds: string[];

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states: string[];

	/**
	 * @generated from field: repeated string visibilities = 10;
	 */
	visibilities: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message brands.v1.ListBrandKitsRequest
 */
export type ListBrandKitsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5 [deprecated = true];
	 * @deprecated
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string creator_ids = 8;
	 */
	creatorIds?: string[];

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states?: string[];

	/**
	 * @generated from field: repeated string visibilities = 10;
	 */
	visibilities?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message brands.v1.ListBrandKitsRequest.
 * Use `create(ListBrandKitsRequestSchema)` to create a new message.
 */
export const ListBrandKitsRequestSchema: GenMessage<ListBrandKitsRequest, { jsonType: ListBrandKitsRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 11);

/**
 * @generated from message brands.v1.ListBrandKitsResponse
 */
export type ListBrandKitsResponse = Message<"brands.v1.ListBrandKitsResponse"> & {
	/**
	 * @generated from field: repeated brands.v1.BrandKit brand_kits = 1;
	 */
	brandKits: BrandKit[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message brands.v1.ListBrandKitsResponse
 */
export type ListBrandKitsResponseJson = {
	/**
	 * @generated from field: repeated brands.v1.BrandKit brand_kits = 1;
	 */
	brandKits?: BrandKitJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message brands.v1.ListBrandKitsResponse.
 * Use `create(ListBrandKitsResponseSchema)` to create a new message.
 */
export const ListBrandKitsResponseSchema: GenMessage<ListBrandKitsResponse, { jsonType: ListBrandKitsResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 12);

/**
 * @generated from message brands.v1.GetBrandKitRequest
 */
export type GetBrandKitRequest = Message<"brands.v1.GetBrandKitRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message brands.v1.GetBrandKitRequest
 */
export type GetBrandKitRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message brands.v1.GetBrandKitRequest.
 * Use `create(GetBrandKitRequestSchema)` to create a new message.
 */
export const GetBrandKitRequestSchema: GenMessage<GetBrandKitRequest, { jsonType: GetBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 13);

/**
 * @generated from message brands.v1.GetBrandKitResponse
 */
export type GetBrandKitResponse = Message<"brands.v1.GetBrandKitResponse"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * @generated from message brands.v1.GetBrandKitResponse
 */
export type GetBrandKitResponseJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.GetBrandKitResponse.
 * Use `create(GetBrandKitResponseSchema)` to create a new message.
 */
export const GetBrandKitResponseSchema: GenMessage<GetBrandKitResponse, { jsonType: GetBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 14);

/**
 * @generated from message brands.v1.GetBrandKitsRequest
 */
export type GetBrandKitsRequest = Message<"brands.v1.GetBrandKitsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message brands.v1.GetBrandKitsRequest
 */
export type GetBrandKitsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message brands.v1.GetBrandKitsRequest.
 * Use `create(GetBrandKitsRequestSchema)` to create a new message.
 */
export const GetBrandKitsRequestSchema: GenMessage<GetBrandKitsRequest, { jsonType: GetBrandKitsRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 15);

/**
 * @generated from message brands.v1.GetBrandKitsResponse
 */
export type GetBrandKitsResponse = Message<"brands.v1.GetBrandKitsResponse"> & {
	/**
	 * @generated from field: repeated brands.v1.BrandKit brand_kits = 1;
	 */
	brandKits: BrandKit[];
};

/**
 * @generated from message brands.v1.GetBrandKitsResponse
 */
export type GetBrandKitsResponseJson = {
	/**
	 * @generated from field: repeated brands.v1.BrandKit brand_kits = 1;
	 */
	brandKits?: BrandKitJson[];
};

/**
 * Describes the message brands.v1.GetBrandKitsResponse.
 * Use `create(GetBrandKitsResponseSchema)` to create a new message.
 */
export const GetBrandKitsResponseSchema: GenMessage<GetBrandKitsResponse, { jsonType: GetBrandKitsResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 16);

/**
 * @generated from message brands.v1.DeleteBrandKitRequest
 */
export type DeleteBrandKitRequest = Message<"brands.v1.DeleteBrandKitRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message brands.v1.DeleteBrandKitRequest
 */
export type DeleteBrandKitRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message brands.v1.DeleteBrandKitRequest.
 * Use `create(DeleteBrandKitRequestSchema)` to create a new message.
 */
export const DeleteBrandKitRequestSchema: GenMessage<DeleteBrandKitRequest, { jsonType: DeleteBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 17);

/**
 * @generated from message brands.v1.DeleteBrandKitResponse
 */
export type DeleteBrandKitResponse = Message<"brands.v1.DeleteBrandKitResponse"> & {};

/**
 * @generated from message brands.v1.DeleteBrandKitResponse
 */
export type DeleteBrandKitResponseJson = {};

/**
 * Describes the message brands.v1.DeleteBrandKitResponse.
 * Use `create(DeleteBrandKitResponseSchema)` to create a new message.
 */
export const DeleteBrandKitResponseSchema: GenMessage<DeleteBrandKitResponse, { jsonType: DeleteBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 18);

/**
 * @generated from message brands.v1.GetDefaultBrandKitRequest
 */
export type GetDefaultBrandKitRequest = Message<"brands.v1.GetDefaultBrandKitRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 2;
	 */
	workspaceId?: string | undefined;
};

/**
 * @generated from message brands.v1.GetDefaultBrandKitRequest
 */
export type GetDefaultBrandKitRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message brands.v1.GetDefaultBrandKitRequest.
 * Use `create(GetDefaultBrandKitRequestSchema)` to create a new message.
 */
export const GetDefaultBrandKitRequestSchema: GenMessage<GetDefaultBrandKitRequest, { jsonType: GetDefaultBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 19);

/**
 * @generated from message brands.v1.GetDefaultBrandKitResponse
 */
export type GetDefaultBrandKitResponse = Message<"brands.v1.GetDefaultBrandKitResponse"> & {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKit | undefined;
};

/**
 * @generated from message brands.v1.GetDefaultBrandKitResponse
 */
export type GetDefaultBrandKitResponseJson = {
	/**
	 * @generated from field: brands.v1.BrandKit brand_kit = 1;
	 */
	brandKit?: BrandKitJson;
};

/**
 * Describes the message brands.v1.GetDefaultBrandKitResponse.
 * Use `create(GetDefaultBrandKitResponseSchema)` to create a new message.
 */
export const GetDefaultBrandKitResponseSchema: GenMessage<GetDefaultBrandKitResponse, { jsonType: GetDefaultBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 20);

/**
 * @generated from message brands.v1.SetDefaultBrandKitRequest
 */
export type SetDefaultBrandKitRequest = Message<"brands.v1.SetDefaultBrandKitRequest"> & {
	/**
	 * @generated from field: optional string id = 1;
	 */
	id?: string | undefined;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string | undefined;
};

/**
 * @generated from message brands.v1.SetDefaultBrandKitRequest
 */
export type SetDefaultBrandKitRequestJson = {
	/**
	 * @generated from field: optional string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string;
};

/**
 * Describes the message brands.v1.SetDefaultBrandKitRequest.
 * Use `create(SetDefaultBrandKitRequestSchema)` to create a new message.
 */
export const SetDefaultBrandKitRequestSchema: GenMessage<SetDefaultBrandKitRequest, { jsonType: SetDefaultBrandKitRequestJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 21);

/**
 * @generated from message brands.v1.SetDefaultBrandKitResponse
 */
export type SetDefaultBrandKitResponse = Message<"brands.v1.SetDefaultBrandKitResponse"> & {};

/**
 * @generated from message brands.v1.SetDefaultBrandKitResponse
 */
export type SetDefaultBrandKitResponseJson = {};

/**
 * Describes the message brands.v1.SetDefaultBrandKitResponse.
 * Use `create(SetDefaultBrandKitResponseSchema)` to create a new message.
 */
export const SetDefaultBrandKitResponseSchema: GenMessage<SetDefaultBrandKitResponse, { jsonType: SetDefaultBrandKitResponseJson }> = /*@__PURE__*/ messageDesc(file_brands_v1_service, 22);

/**
 * @generated from enum brands.v1.ImageType
 */
export enum ImageType {
	/**
	 * @generated from enum value: IMAGE_TYPE_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: IMAGE_TYPE_LOGO = 1;
	 */
	LOGO = 1,

	/**
	 * @generated from enum value: IMAGE_TYPE_ICON = 2;
	 */
	ICON = 2,

	/**
	 * @generated from enum value: IMAGE_TYPE_SYMBOL = 3;
	 */
	SYMBOL = 3,

	/**
	 * @generated from enum value: IMAGE_TYPE_BANNER = 4;
	 */
	BANNER = 4,

	/**
	 * @generated from enum value: IMAGE_TYPE_BACKGROUND = 5;
	 */
	BACKGROUND = 5,
}

/**
 * @generated from enum brands.v1.ImageType
 */
export type ImageTypeJson = "IMAGE_TYPE_UNKNOWN" | "IMAGE_TYPE_LOGO" | "IMAGE_TYPE_ICON" | "IMAGE_TYPE_SYMBOL" | "IMAGE_TYPE_BANNER" | "IMAGE_TYPE_BACKGROUND";

/**
 * Describes the enum brands.v1.ImageType.
 */
export const ImageTypeSchema: GenEnum<ImageType, ImageTypeJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 0);

/**
 * @generated from enum brands.v1.ImageTheme
 */
export enum ImageTheme {
	/**
	 * @generated from enum value: IMAGE_THEME_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: IMAGE_THEME_DARK = 1;
	 */
	DARK = 1,

	/**
	 * @generated from enum value: IMAGE_THEME_LIGHT = 2;
	 */
	LIGHT = 2,
}

/**
 * @generated from enum brands.v1.ImageTheme
 */
export type ImageThemeJson = "IMAGE_THEME_UNKNOWN" | "IMAGE_THEME_DARK" | "IMAGE_THEME_LIGHT";

/**
 * Describes the enum brands.v1.ImageTheme.
 */
export const ImageThemeSchema: GenEnum<ImageTheme, ImageThemeJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 1);

/**
 * @generated from enum brands.v1.ImageFormat
 */
export enum ImageFormat {
	/**
	 * @generated from enum value: IMAGE_FORMAT_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: IMAGE_FORMAT_PNG = 1;
	 */
	PNG = 1,

	/**
	 * @generated from enum value: IMAGE_FORMAT_JPEG = 2;
	 */
	JPEG = 2,

	/**
	 * @generated from enum value: IMAGE_FORMAT_SVG = 3;
	 */
	SVG = 3,
}

/**
 * @generated from enum brands.v1.ImageFormat
 */
export type ImageFormatJson = "IMAGE_FORMAT_UNKNOWN" | "IMAGE_FORMAT_PNG" | "IMAGE_FORMAT_JPEG" | "IMAGE_FORMAT_SVG";

/**
 * Describes the enum brands.v1.ImageFormat.
 */
export const ImageFormatSchema: GenEnum<ImageFormat, ImageFormatJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 2);

/**
 * @generated from enum brands.v1.ImageBackground
 */
export enum ImageBackground {
	/**
	 * @generated from enum value: IMAGE_BACKGROUND_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: IMAGE_BACKGROUND_TRANSPARENT = 1;
	 */
	TRANSPARENT = 1,
}

/**
 * @generated from enum brands.v1.ImageBackground
 */
export type ImageBackgroundJson = "IMAGE_BACKGROUND_UNKNOWN" | "IMAGE_BACKGROUND_TRANSPARENT";

/**
 * Describes the enum brands.v1.ImageBackground.
 */
export const ImageBackgroundSchema: GenEnum<ImageBackground, ImageBackgroundJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 3);

/**
 * @generated from enum brands.v1.ColorTheme
 */
export enum ColorTheme {
	/**
	 * @generated from enum value: COLOR_THEME_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: COLOR_THEME_DARK = 1;
	 */
	DARK = 1,

	/**
	 * @generated from enum value: COLOR_THEME_LIGHT = 2;
	 */
	LIGHT = 2,
}

/**
 * @generated from enum brands.v1.ColorTheme
 */
export type ColorThemeJson = "COLOR_THEME_UNKNOWN" | "COLOR_THEME_DARK" | "COLOR_THEME_LIGHT";

/**
 * Describes the enum brands.v1.ColorTheme.
 */
export const ColorThemeSchema: GenEnum<ColorTheme, ColorThemeJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 4);

/**
 * @generated from enum brands.v1.ColorType
 */
export enum ColorType {
	/**
	 * @generated from enum value: COLOR_TYPE_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: COLOR_TYPE_DARK = 1;
	 */
	DARK = 1,

	/**
	 * @generated from enum value: COLOR_TYPE_LIGHT = 2;
	 */
	LIGHT = 2,

	/**
	 * @generated from enum value: COLOR_TYPE_ACCENT = 3;
	 */
	ACCENT = 3,

	/**
	 * @generated from enum value: COLOR_TYPE_BRAND = 4;
	 */
	BRAND = 4,
}

/**
 * @generated from enum brands.v1.ColorType
 */
export type ColorTypeJson = "COLOR_TYPE_UNKNOWN" | "COLOR_TYPE_DARK" | "COLOR_TYPE_LIGHT" | "COLOR_TYPE_ACCENT" | "COLOR_TYPE_BRAND";

/**
 * Describes the enum brands.v1.ColorType.
 */
export const ColorTypeSchema: GenEnum<ColorType, ColorTypeJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 5);

/**
 * @generated from enum brands.v1.FontOrigin
 */
export enum FontOrigin {
	/**
	 * @generated from enum value: FONT_ORIGIN_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: FONT_ORIGIN_GOOGLE = 1;
	 */
	GOOGLE = 1,

	/**
	 * @generated from enum value: FONT_ORIGIN_CUSTOM = 2;
	 */
	CUSTOM = 2,
}

/**
 * @generated from enum brands.v1.FontOrigin
 */
export type FontOriginJson = "FONT_ORIGIN_UNKNOWN" | "FONT_ORIGIN_GOOGLE" | "FONT_ORIGIN_CUSTOM";

/**
 * Describes the enum brands.v1.FontOrigin.
 */
export const FontOriginSchema: GenEnum<FontOrigin, FontOriginJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 6);

/**
 * @generated from enum brands.v1.FontUseCase
 */
export enum FontUseCase {
	/**
	 * @generated from enum value: FONT_USE_CASE_UNKNOWN = 0;
	 */
	UNKNOWN = 0,

	/**
	 * @generated from enum value: FONT_USE_CASE_HEADER = 1;
	 */
	HEADER = 1,

	/**
	 * @generated from enum value: FONT_USE_CASE_BODY = 2;
	 */
	BODY = 2,

	/**
	 * @generated from enum value: FONT_USE_CASE_BUTTON = 3;
	 */
	BUTTON = 3,
}

/**
 * @generated from enum brands.v1.FontUseCase
 */
export type FontUseCaseJson = "FONT_USE_CASE_UNKNOWN" | "FONT_USE_CASE_HEADER" | "FONT_USE_CASE_BODY" | "FONT_USE_CASE_BUTTON";

/**
 * Describes the enum brands.v1.FontUseCase.
 */
export const FontUseCaseSchema: GenEnum<FontUseCase, FontUseCaseJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 7);

/**
 * @generated from enum brands.v1.CodeType
 */
export enum CodeType {
	/**
	 * @generated from enum value: CODE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CODE_TYPE_PRINT = 1;
	 */
	PRINT = 1,

	/**
	 * @generated from enum value: CODE_TYPE_JUMBOTRON = 2;
	 */
	JUMBOTRON = 2,

	/**
	 * @generated from enum value: CODE_TYPE_TV = 3;
	 */
	TV = 3,
}

/**
 * @generated from enum brands.v1.CodeType
 */
export type CodeTypeJson = "CODE_TYPE_UNSPECIFIED" | "CODE_TYPE_PRINT" | "CODE_TYPE_JUMBOTRON" | "CODE_TYPE_TV";

/**
 * Describes the enum brands.v1.CodeType.
 */
export const CodeTypeSchema: GenEnum<CodeType, CodeTypeJson> = /*@__PURE__*/ enumDesc(file_brands_v1_service, 8);

/**
 * The Brands Service is responsible for managing the storage of BrandKits in the assets service.
 *
 * @generated from service brands.v1.BrandsService
 */
export const BrandsService: GenService<{
	/**
	 * @generated from rpc brands.v1.BrandsService.GetDefaultBrandKit
	 */
	getDefaultBrandKit: {
		methodKind: "unary";
		input: typeof GetDefaultBrandKitRequestSchema;
		output: typeof GetDefaultBrandKitResponseSchema;
	};
	/**
	 * @generated from rpc brands.v1.BrandsService.SetDefaultBrandKit
	 */
	setDefaultBrandKit: {
		methodKind: "unary";
		input: typeof SetDefaultBrandKitRequestSchema;
		output: typeof SetDefaultBrandKitResponseSchema;
	};
	/**
	 * Creates a BrandKit from a BrandKit or URL.
	 *
	 * @generated from rpc brands.v1.BrandsService.CreateBrandKit
	 */
	createBrandKit: {
		methodKind: "unary";
		input: typeof CreateBrandKitRequestSchema;
		output: typeof CreateBrandKitResponseSchema;
	};
	/**
	 * @generated from rpc brands.v1.BrandsService.GenerateBrandKit
	 */
	generateBrandKit: {
		methodKind: "unary";
		input: typeof GenerateBrandKitRequestSchema;
		output: typeof GenerateBrandKitResponseSchema;
	};
	/**
	 * Updates the existing BrandKit with the given id.
	 *
	 * @generated from rpc brands.v1.BrandsService.UpdateBrandKit
	 */
	updateBrandKit: {
		methodKind: "unary";
		input: typeof UpdateBrandKitRequestSchema;
		output: typeof UpdateBrandKitResponseSchema;
	};
	/**
	 * Lists the set of BrandKit objects.
	 *
	 * @generated from rpc brands.v1.BrandsService.ListBrandKits
	 */
	listBrandKits: {
		methodKind: "unary";
		input: typeof ListBrandKitsRequestSchema;
		output: typeof ListBrandKitsResponseSchema;
	};
	/**
	 * Gets and returns a BrandKit with the given id.
	 *
	 * @generated from rpc brands.v1.BrandsService.GetBrandKit
	 */
	getBrandKit: {
		methodKind: "unary";
		input: typeof GetBrandKitRequestSchema;
		output: typeof GetBrandKitResponseSchema;
	};
	/**
	 * @generated from rpc brands.v1.BrandsService.GetBrandKits
	 */
	getBrandKits: {
		methodKind: "unary";
		input: typeof GetBrandKitsRequestSchema;
		output: typeof GetBrandKitsResponseSchema;
	};
	/**
	 * Deletes a BrandKit with the given id
	 *
	 * @generated from rpc brands.v1.BrandsService.DeleteBrandKit
	 */
	deleteBrandKit: {
		methodKind: "unary";
		input: typeof DeleteBrandKitRequestSchema;
		output: typeof DeleteBrandKitResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_brands_v1_service, 0);
